import { render, staticRenderFns } from "./approveUpdateContract.vue?vue&type=template&id=e36caa88"
import script from "./approveUpdateContract.vue?vue&type=script&lang=js"
export * from "./approveUpdateContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports